import { useEffect, useState } from 'react';
import io, { Socket } from 'socket.io-client';
import config from '../config';
import { useApplicationContext } from '../modules/context/ApplicationContext/ApplicationContext';

export enum DownloadMediasEventsEnum {
  MEDIAS_PROCESSED = 'medias-processed',
}

export const useDownloadMediasNotifier = () => {
  const [socket, setSocket] = useState<Socket>();

  const { state } = useApplicationContext();

  useEffect(() => {
    if (!state.user?.userId) {
      return;
    }

    const newSocket = io(`${config.websocketUrl}/notify-process`, {
      path: '/ws',
      transports: ['websocket'],
      forceNew: true,
      query: {
        userId: state.user?.userId,
      },
    });
    setSocket(newSocket);

    return () => {
      newSocket.close();
      setSocket(undefined);
    };
  }, [state.user?.userId]);

  return socket;
};
